import { mapSeriesWithDatetime } from './shared';

export default {
  buildFields() {
    return [
      { key: 'datetime', label: 'Date Time', class: 'text-center' },
      { key: 'cpuUsage', label: 'CPU Usage (%)', class: 'text-center' },
      { key: 'memoryFree', label: 'Memory Free (%)', class: 'text-center' },
      { key: 'spaceFree', label: 'Space Free (%)', class: 'text-center' },
    ];
  },
  buildLogs(seriesData) {
    return mapSeriesWithDatetime(seriesData, (serie) => ({
      cpuUsage: (serie.cpuUsage * 100).toFixed(2),
      memoryFree: (serie.memoryFree * 100).toFixed(2),
      spaceFree: (serie.spaceFree * 100).toFixed(2),
    }));
  },
  buildSummary() {
    return {};
  },
};
